import IndexedDB from "../IndexedDB";
import ActivityLogDB from "../IndexedDB/ActivityLogDB";
import { ILogBase } from "../Middleware/LoggingMiddleware";
import { LoggingLevel } from "../Enums/shared";
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';


export default class LogUtils {
  private static _logInterval?: any;

  static set LogInterval(intervalData: any) {
    this._logInterval = intervalData;
  }

  static get LogInterval(): any {
    return this._logInterval;
  }

  static async postLogData(
    requestURL: string,
    onSuccess: (result: string) => void,
    onError: (error: any) => void
  ) {
    try {
      //call web api
      await IndexedDB.initDb();
      //Select logdata to emit based on log level config setting for agency, if not available use default logging level error
      let logData: ILogBase[] = await ActivityLogDB.getAllActivityLogs();

      if (logData && logData.length > 0) {

        Api.post(requestURL, logData).then(async (res: ApiResponse<any>) => {
          if (res.ok) {
            onSuccess("Successfully pushed all activity logs!");
            await ActivityLogDB.clearAllActivityLogData().catch(err => onError(err));
          } else {
            console.warn('Failed to push activity logs! Please refer to the following for more info: ' + res);
          }
        });
      }
    } catch (err) {
      console.error(err);
      onError(err);
    }
  }
}
